angular.module("dx.webapp.region", [
	"dx.webapp.navigation",

	"ngCookies",
]);
